import { AnchoringVesselAtAnchorData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const dataTag = 'AnchoringVesselAtAnchorData';
export default class AnchoringVesselAtAnchorParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.ANCHORING_VESSEL_AT_ANCHOR, FIXED_PROTOCOL_CONTENT_TYPE_IDS.ANCHORING_VESSEL_AT_ANCHOR, dataTag, app);
    }
    getPropsMapping() {
        return {
            anchor: 'anchor',
            freeText: 'freeText',
            chainLegth: 'chainLength',
            chainShake: 'chainShake',
        };
    }
    createData(props, record) {
        const data = new AnchoringVesselAtAnchorData(props.anchor, props.chainLength, props.chainShake, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.anchor,
            };
            data.anchor = link;
        }
        return data;
    }
}
//# sourceMappingURL=AnchoringVesselAtAnchorParser.js.map